import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {InjectionRootComponent} from '../injection-root/injection-root.component';
import {RequestBodyVacations} from '../InjectionVO';
import {TimeZoneService} from '../../../service/TimeZoneService';
import * as moment from 'moment';
import {ApiService} from '../api.service';
import {BaseComponent} from '../BaseComponent';
import {environment} from '../../../../environments/environment';
import {TadInHoursVO} from '../../../model/tadInHoursVO';
import {TadInHoursFilter} from '../../../model/tadInHoursFilter';
import {UserService} from '../../../service/UserService';
import {TranslateService} from '@ngx-translate/core';
import {FeatureAccessService} from '../../../service/feature-access.service';

class BlockRealizeValidate {
  start:string
  end:string
}

@Component({
  selector: 'app-modal-tad-hours',
  templateUrl: './modal-tad-hours.component.html',
  styleUrls: ['./modal-tad-hours.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ModalTadHoursComponent extends BaseComponent implements OnInit {
  panelOpenState = true;
  panelOpenStateTadeHours = false;

  listTad: TadInHoursVO[] = [];
  listTadOld: TadInHoursVO[] = [];
  listTadWs: TadInHoursVO[] = [];
  startDate: string;
  countryCode: string;
  endDate: string;
  public data: any;
  matricule: string = '';
  hoursBreakFiletred: Array<any> = this.hoursBreak;
  hoursBreakChecked: Array<any> = this.hoursBreak;
  date: any;
  dateTransform: any;
  injectionData: RequestBodyVacations = new RequestBodyVacations();
  blockRealizeValidate:BlockRealizeValidate[] = [];
  hasError: boolean = false;
  disabledButtonSave:boolean = true;
  readonly :boolean = false;
  _send : boolean = false;
  messageError = "";
  constructor(public dialogRef: MatDialogRef<InjectionRootComponent>, public tz: TimeZoneService,
              public userService: UserService,
              @Inject(MAT_DIALOG_DATA) public injectData: any, private serviceApi: ApiService, private translate: TranslateService) {
    super();
  }

  ngOnInit() {
    this.data = this.injectData;
    const currentLang = this.translate.currentLang || 'fr';
    this.countryCode = this.userService.getUserCountry();
    console.log('this.injectData : ', this.injectData);
    let dataBlockTemps = [];
    if (this.injectData.dataset && this.injectData.dataset.length>2) {
      this.readonly = this.injectData['readonly'];
      dataBlockTemps = this.injectData.dataset[2].disp_data.filter(temp=> ['UNKNOWN', 'EMPTY'].indexOf(temp[1]) === -1)
    }
    dataBlockTemps.forEach(bTemps => {
      if (bTemps[1] !== "FULFILLED_VALIDATED_INSERVICE_TAD"){
        let temps : BlockRealizeValidate = new BlockRealizeValidate();
        temps.start = bTemps[0];
        temps.end = bTemps[2];
        this.blockRealizeValidate.push(temps);
      }
    });


    this.matricule = JSON.parse(localStorage.getItem(environment.oauth.remoteUser)).userName;
    this.date = moment(this.data.user.date).format('YYYY-MM-DD');
    this.dateTransform = moment(this.date).locale(currentLang).format('dddd DD MMMM Y');
    this.getAllTadHours(this.data, this.date, this.matricule);
  }

  cancel() {
    this.dialogRef.close();

  }

  validate() {
    if(this.readonly) return;
    this._send = true;
    this.messageError = "";
    console.log('All tad ', this.listTad);
    let payload : TadInHoursVO[] = [];
    this.listTad.forEach(tad=>{
      let t : TadInHoursVO = new TadInHoursVO();
      t.startTime = tad.startTime;
      t.endTime = tad.endTime;
      t.id = tad.id;
      t.date = this.date;
      t.allDay = this.panelOpenStateTadeHours;
      t.createdBy = this.matricule;
      t.registrationNumber = this.data.user.username;
      t.deleted = tad.deleted;

      payload.push(t);
    })

    this.serviceApi.saveTadInHours(payload,this.matricule)
      .subscribe(res=> {
        this.refreshBlock();
        this._send = false;
      },error => {
        this._send = false;
        this.messageError = error.error.message;
      })

    console.log("tads : ",payload);
  }
  refreshBlock() {
    this.dialogRef.close(true);
    this.dialogRef.afterClosed().subscribe(() => {
      let el = document.querySelector('.dataset .INCOHERENCE_OFF');
      if(!el) el = document.querySelector('.dataset .INCOHERENCE_ON');
    })
  }

  toggleChangedTadHours() {
    this.panelOpenStateTadeHours = !this.panelOpenStateTadeHours;
    if (this.panelOpenStateTadeHours) {
      this.listTad = this.listTad.filter(t => t.id);
      this.listTad.forEach(tad=> tad.deleted = true);
      this.panelOpenState = false;
      this.blockRealizeValidate.forEach(b => {
        let tad :TadInHoursVO = new TadInHoursVO();
        tad.startTime = moment(b.start).format( 'HH:mm:ss');
        tad.endTime = moment(b.end).format( 'HH:mm:ss');
        this.listTad.push(tad);
      });
      this.listTad = this.mergeBlockV2(this.listTad);
    } else {
      this.listTad.forEach(tad=> tad.deleted = true);
      this.panelOpenState = true;
      this.startDate = '';
      this.endDate = '';

    }

  }

  toggleChanged() {
    this.panelOpenState = !this.panelOpenState;
    if (this.panelOpenState) {
      this.panelOpenStateTadeHours = false;
      console.log('listTadWs', this.listTadWs);
      if (this.listTadWs.filter(t=> t.allDay).length>0){
        this.listTad = this.listTadWs.filter(t => t.id);
      }
      this.listTad.forEach(tad=> tad.deleted = true);
    }
  }

  inHoursBreak() {
    let findMinute = j => j < 10 ? '0' + j : j;
    this.hoursBreak = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j++) {
        let time = i + ':' + findMinute(j);
        if (i < 10) {
          time = '0' + time;
        }
        this.hoursBreak.push(time);
      }
    }
  }

  doFilter(filter: string) {
    this.hoursBreakFiletred = this.hoursBreakChecked.filter((hour) =>
      hour.includes(filter)
    );
  }

  deleteTadHour(tad: TadInHoursVO, index: number) {
    if (!this.panelOpenStateTadeHours){
      if (tad.id) {
        tad.deleted = true;
      } else {
        this.listTad = this.listTad.filter((t, i) => t.startTime != tad.startTime && t.endTime != tad.endTime || t.id);
      }
      this.disabledButtonSave = false;
    }
    if (this.listTad.length == 0 && this.listTadWs.length == 0)
      this.disabledButtonSave = true;
    else if (this.listTadWs.length>0)
      this.disabledButtonSave = false;


  }

  addTadHour() {
    if (this.startDate && this.endDate && !this.panelOpenStateTadeHours) {
      this.listTad.filter(tad=>tad.allDay).forEach(tad=> tad.deleted = true);
      let tadToadd =[];
      const sp = moment(this.startDate, 'HH:mm:ss');
      const ep = moment(this.endDate, 'HH:mm:ss');
      let dateStart = moment(this.blockRealizeValidate[0].start).format("HH:mm:ss");
      let dateEnd = moment(this.blockRealizeValidate[this.blockRealizeValidate.length-1].end).format("HH:mm:ss");
      if (sp.isSame(dateStart) && ep.isSame(dateEnd)){
        this.toggleChangedTadHours();
        this.disabledButtonSave = false;
      }else{
        console.table('blockRealizeValidate', this.blockRealizeValidate);
        let list = this.blockRealizeValidate
          .filter(b => {
            let dateStart = moment(b.start).format("HH:mm:ss");
            let dateEnd = moment(b.end).format("HH:mm:ss");
            return (
              (moment(dateStart, 'HH:mm:ss').isSameOrAfter(sp) && moment(dateStart, 'HH:mm:ss').isSameOrBefore(ep))
              || (moment(dateEnd, 'HH:mm:ss').isSameOrAfter(sp) && moment(dateEnd, 'HH:mm:ss').isSameOrBefore(ep)));
          });
        if (list.length>0){
          list.forEach((tad,index)=> {
            let dateStart = moment(tad.start).format("HH:mm:ss");
            let dateEnd = moment(tad.end).format("HH:mm:ss");
            if (moment(dateEnd, 'HH:mm:ss').isSameOrBefore(ep)){
              if(sp.isSameOrAfter(moment(dateStart, 'HH:mm:ss')) && moment(dateEnd, 'HH:mm:ss').isAfter(sp)){
                let tad: TadInHoursVO = new TadInHoursVO();
                tad.startTime = this.startDate;
                tad.endTime = dateEnd
                if (sp.isBefore(moment(dateEnd, 'HH:mm:ss')))
                  tadToadd.push(tad);
              }else{
                if (ep.isSameOrBefore(moment(dateEnd, 'HH:mm:ss')) && moment(dateEnd, 'HH:mm:ss').isAfter(sp)){
                  let tad: TadInHoursVO = new TadInHoursVO();
                  tad.startTime = dateStart;
                  tad.endTime = this.endDate
                  if (moment(dateStart, 'HH:mm:ss').isBefore(ep))
                    tadToadd.push(tad);
                }else {
                  if (moment(dateEnd, 'HH:mm:ss').isAfter(sp)){
                    let tad: TadInHoursVO = new TadInHoursVO();
                    tad.startTime = dateStart;
                    tad.endTime = dateEnd;
                    tadToadd.push(tad);
                  }
                }
              }
            }else if (ep.isSameOrBefore(moment(dateEnd, 'HH:mm:ss')) && moment(dateStart, 'HH:mm:ss').isSameOrAfter(sp)){
              let tad: TadInHoursVO = new TadInHoursVO();
              tad.startTime = dateStart;
              tad.endTime = this.endDate;
              if (moment(dateStart, 'HH:mm:ss').isBefore(ep))
                tadToadd.push(tad);
            }
          })
        } else{
          let tad: TadInHoursVO = new TadInHoursVO();
          tad.startTime = this.startDate;
          tad.endTime = this.endDate;
          tadToadd.push(tad);
          this.disabledButtonSave = false;
        }
        //this.listTad = this.listTad.filter(tad=> moment(tad.startTime, 'HH:mm:ss').isSameOrBefore(ep) || tad.deleted);
        this.listTad.push(...this.mergeBlockV2(tadToadd));
      }
      this.initDate();
    }

  }

  mergeBlockV2(data: any) {
    if (!data.length) { return data; }
    data = data.next(({current, workAt, prev, next, push, index}) => {
      let st: any = new Date('2023-11-01 ' + next.startTime);
      let et: any = new Date('2023-11-01 '  + current.endTime);
      st = st.getTime();
      et = et.getTime();
      if (st === et) {
        workAt.endTime = next.endTime;
      }
      if (!(st === et)) {
        push(workAt);
      }
      return !(st === et);
    });
    return data;
  }


  private getAllTadHours(data: any, date: any, matricule: string) {
    let filter: TadInHoursFilter = new TadInHoursFilter();
    filter.deleted = false;
    //filter.createdBy = matricule;
    filter.registrationNumber = data.user.username;
    this.serviceApi.getAllTadHours(filter).subscribe(allTads => {
      this.listTad = allTads.filter(t=> t.date == date);
      this.listTadWs = this.listTad;
      this.panelOpenState = false;
      if(this.listTad && this.listTad.length){
        this.panelOpenStateTadeHours  = this.listTad.filter(t=> t.allDay).length > 0;
        this.panelOpenState = !this.panelOpenStateTadeHours;
      }
    });

  }

  findTadsNoDeleted() {
    return this.listTad.filter(t => !t.deleted);
  }

  private initDate() {
    this.startDate = '';
    this.endDate = '';
  }
  formatTadHours(d, h) {
    return moment(`${d} ${h}`).format('YYYY-MM-DD HH:mm:ss');
  }

  InTadPeriod() {
    if (!this.panelOpenStateTadeHours) {
      this.hasError = false;
      const sp = moment(this.startDate, 'HH:mm:ss');
      const ep = moment(this.endDate, 'HH:mm:ss');
      if (this.listTad.filter(value => {
        let x1 = (sp.isSame(moment(value.startTime, 'HH:mm:ss')) || sp.isSame(moment(value.endTime, 'HH:mm:ss'))) || sp.isBetween(moment(value.startTime, 'HH:mm:ss'), moment(value.endTime, 'HH:mm:ss'));
        let x2 =  (ep.isSame(moment(value.startTime, 'HH:mm:ss')) || ep.isSame(moment(value.endTime, 'HH:mm:ss')))  || (ep.isBetween(moment(value.startTime, 'HH:mm:ss'), moment(value.endTime, 'HH:mm:ss')));
        return !value.deleted && (x1 || x2);
      }).length > 0){
        this.hasError = true;
        return 'Attention chevauchement des intervalles';
      }
      if (this.startDate && this.endDate) {
        if (ep.isSameOrBefore(sp)) {
          this.hasError = true;
          return 'L\'heure de fin saisie est inférieure à l\'heure de début';
        }
      }
      if (this.startDate && !this.endDate) {
        this.hasError = true;
        this.disabledButtonSave = true;
        return 'L\'heure de fin de TAD n\'est pas saisie';
      }

      if (!this.startDate && this.endDate) {
        this.hasError = true;
        return 'L\'heure de début du TAD n\'est pas saisie';
      }
    } else {
      this.hasError = false;
    }
    return null;

  }

  isDisableBtn() {

    if (!this.panelOpenStateTadeHours) {
      this.disabledButtonSave = false;
      const sp = moment(this.startDate, 'HH:mm:ss');
      const ep = moment(this.endDate, 'HH:mm:ss');
      if (this.startDate && this.endDate) {
        if (ep.isSameOrBefore(sp)) {
          this.hasError = true;
          this.disabledButtonSave = true;
        }
        if (this.listTad.filter(value => {
          let x1 = (sp.isSame(moment(value.startTime, 'HH:mm:ss')) || sp.isSame(moment(value.endTime, 'HH:mm:ss'))) || sp.isBetween(moment(value.startTime, 'HH:mm:ss'), moment(value.endTime, 'HH:mm:ss'));
          let x2 =  (ep.isSame(moment(value.startTime, 'HH:mm:ss')) || ep.isSame(moment(value.endTime, 'HH:mm:ss')))  || (ep.isBetween(moment(value.startTime, 'HH:mm:ss'), moment(value.endTime, 'HH:mm:ss')));
          return !value.deleted && (x1 || x2);
        }).length > 0){
          this.hasError = true;
          this.disabledButtonSave = true;
        }
      }
      if (this.startDate && !this.endDate) {
        this.hasError = true;
        this.disabledButtonSave = true;
      }

      if (!this.startDate && this.endDate) {
        this.hasError = true;
        this.disabledButtonSave = true;
      }
    } else {
      this.hasError = false;
      this.disabledButtonSave = false;
    }
    if (this.listTad.filter(t=> !t.deleted).length == 0 && this.listTadWs.length>0) this.disabledButtonSave = false

    return this.disabledButtonSave;
  }

  protected readonly FeatureAccessService = FeatureAccessService;
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/modal-tad-hours/modal-tad-hours.component.ts